var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSecrets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 93,
    viewBox: "0 0 75 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_213905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 93,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3857 85.2538L29.5614 81.2622L43.5141 89.2454L36.7371 93.237L22.3857 85.2538Z",
    fill: "url(#paint0_linear_66_213905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5136 83.6572V44.5396L36.3379 46.1362V87.6488L43.5136 83.6572Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5076 36.5563C45.5076 26.5774 33.5481 7.81685 21.9873 13.0059C23.1833 12.2076 29.163 8.61517 30.3589 8.21601C35.94 7.01853 41.1224 11.0101 44.7103 15.0017C50.69 21.3883 56.6697 36.1572 48.2981 42.5437L41.5211 46.5353C44.3116 44.9387 45.9062 40.9471 45.5076 36.5563Z",
    fill: "url(#paint1_linear_66_213905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9527 13.4052C24.3784 9.01444 18 12.6069 18 21.3884C18 28.1741 21.5878 36.1573 26.7703 41.3464V48.9304L31.5541 54.1195H26.7703V59.3086L31.5541 64.4976H26.7703V70.0859L31.5541 75.2749H27.1689V78.4682L36.3378 88.4472V47.3338C41.9189 48.5312 45.9054 44.9388 45.9054 37.7539C45.9054 28.5733 39.9257 17.796 31.9527 13.4052Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1554 19.7918C29.1622 18.5943 27.1689 19.3926 27.1689 22.1868C27.1689 24.9809 28.7635 28.1741 31.1554 29.3716C33.1487 30.5691 35.1419 29.7708 35.1419 26.9767C35.1419 24.5817 33.5473 20.9893 31.1554 19.7918Z",
    fill: "url(#paint2_linear_66_213905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1422 86.0521L33.9463 85.2538V50.5269L35.1422 50.926V86.0521Z",
    fill: "#A7A7A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_213905",
    x1: 25.9696,
    y1: 91.3338,
    x2: 39.9799,
    y2: 83.2556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_213905",
    x1: 47.8201,
    y1: 43.3449,
    x2: 31.1735,
    y2: 7.69148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3834,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_213905",
    x1: 33.2133,
    y1: 30.1875,
    x2: 29.1762,
    y2: 19.1106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_213905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSecrets);
export default __webpack_public_path__ + "static/media/no_secrets.3ccbc5ab13c4ac71fe361934004ae5fd.svg";
export { ForwardRef as ReactComponent };